// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2Bkhy","amount":"Amount_amount__33LZF","tip":"Amount_tip__pJA_3","tipHeader":"Amount_tipHeader__2bZKf","tipsWrap":"Amount_tipsWrap__kMhum"};